import { useRef, useState } from "react";

import formatRelative from 'date-fns/formatRelative';
import ptBR from 'date-fns/locale/pt-BR';

import { ReactComponent as BellIcon } from 'assets/icons/bell.svg';
import useNotification from "hooks/UseNotification";

import { CenteredText, Container, Notification, NotificationBellButton, NotificationContent, NotificationHeading, NotificationsList, NotificationsWrapper, NotificationTime } from "./_notificationBell";
import { useOutside } from "hooks/UseOutside";

interface INotificationBellProps {
  pathname: string;
}

const formatRelativeLocale = {
  ...ptBR.formatRelative,
  today: "'Hoje às' HH:mm'h'",
  yesterday: "'Ontem às' HH:mm'h'",
  lastWeek: "dd/MM/yyyy 'às' HH:mm'h'",
  other: "dd/MM/yyyy 'às' HH:mm'h'",
} as { [key: string]: string };

export const locale = {
  ...ptBR,
  formatRelative: (token: string) => formatRelativeLocale[token],
};

export const NotificationBell = ({ pathname }: INotificationBellProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const {
      canReceivePushNotifications,
      handleOpenNativeNotificationPrompt,
      notifications,
    } = useNotification();
  const [readNotifications, setReadNotifications] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleClose = () => {
    setIsExpanded(false);
  };

  const handleToggleNotifications = () => {
    if(!canReceivePushNotifications) {
      handleOpenNativeNotificationPrompt();
      return;
    }

    setReadNotifications(notifications.length);
    setIsExpanded(prevState => !prevState);
  }

  useOutside(containerRef, handleClose);

  return (
    <Container ref={containerRef}>
      <NotificationBellButton
        pathname={pathname}
        onClick={handleToggleNotifications}
        hasNewNotifications={notifications.length > readNotifications}
      >
        <BellIcon />
      </NotificationBellButton>
      <NotificationsWrapper isExpanded={isExpanded}>
        <NotificationsList isExpanded={isExpanded}>
          { notifications.length === 0 ? (
              <CenteredText>
                Nenhuma notificação recebida!
              </CenteredText>
            ) :
            notifications.map((notification) => (
              <Notification
                key={notification.id}
              >
                <NotificationHeading>{notification.heading}</NotificationHeading>
                <NotificationContent>
                  {notification.content}
                </NotificationContent>
                <NotificationTime>
                  {formatRelative(notification.date, new Date(), {
                    locale,
                  })}
                </NotificationTime>
              </Notification>
            ))
          }
        </NotificationsList>
      </NotificationsWrapper>
    </Container>
  )
}
